import {
  Chart as ChartJs,
  Colors,
  Filler,
  Legend,
  LineController,
  LineElement,
  LinearScale,
  PointElement,
  ScatterController,
  TimeScale,
  Title,
  Tooltip,
  type Plugin
} from "chart.js";
import "chartjs-adapter-moment";
import annotationPlugin from "chartjs-plugin-annotation";
import drawAliasOrNameLabel from "../plugins/drawAliasOrNameLabel";
import drawInclinationLabel from "../plugins/drawInclinationLabel";
import drawPointLabel from "../plugins/drawPointLabel";

let initialized = false;

const customLabelPlugin: Plugin = {
  id: "siisel-custom-labels",
  afterDatasetsDraw(chart) {
    drawPointLabel(chart);
    drawInclinationLabel(chart);
    drawAliasOrNameLabel(chart);
  }
};

export function ensureChartJsSetup(): void {
  if (initialized) {
    return;
  }

  ChartJs.register(
    ScatterController,
    LineController,
    PointElement,
    LineElement,
    LinearScale,
    TimeScale,
    Tooltip,
    Legend,
    Title,
    Filler,
    Colors,
    annotationPlugin,
    customLabelPlugin
  );

  initialized = true;
}
